













import { Component, Prop, Vue } from "vue-property-decorator";
import {
  GridColumnTypes,
  GridColumn,
  GridAction} from "@/models/grids/column";
import { FeedbackDto, FeedbackQuestionGroup, FeedbackQuestionType ,LanguageDto } from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import { Getter } from "vuex-class";
import { FeedbackQuestionGroupsService } from "@/services/api/feedback.questiongroups.service";
import { FeedbackQuestionTypeService } from "@/services/api/feedback.questiontypes.service";
import { GetFeedbackQuestionGroupDtosIncludeOptions, GetFeedbackQuestionGroupDtosQuery, GetFeedbackQuestionGroupsDtosOrderOptions, GetFeedbackQuestionTypesDtosQuery } from "@/server/app.queries";
import { ListResponse } from "@/models/grids/list.response";

@Component
export default class FeedbackQuestionsPage extends Vue {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Prop() feedback!: FeedbackDto;
  apiService: ConfigsService = new ConfigsService();
  feedbackQuestionGroupService: FeedbackQuestionGroupsService = new FeedbackQuestionGroupsService();
  feedbackQuestionTypeService: FeedbackQuestionTypeService = new FeedbackQuestionTypeService();
  groups: FeedbackQuestionGroup[] = [];
  questionTypes: FeedbackQuestionType[] = [];
  columns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Descripção",
      value: "description",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Tipo de Pergunta",
      value: "idFeedbackQuestionType",
      type: GridColumnTypes.Dropdown,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.required],
      arg: {
        items: [],
        itemText: "title",
        itemValue: "idFeedbackQuestionType",
        value: null
      }
    },
    {
      text: "Grupo de Questao",
      value: "idFeedbackQuestionGroup",
      type: GridColumnTypes.Dropdown,
      editable: true,
      filterable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.required],
      arg: {
        items: [],
        itemText: "title",
        itemValue: "idFeedbackQuestionGroup",
        value: null
      }
    },
    {
      text: "Ponderacao",
      value: "reflection",
      type: GridColumnTypes.Interger,
      editable: true,
      editableClass: "col-12", 
      editableRules: [this.$rules.required]
    }
  ];
  actions: GridAction[] = [
    {
      title: "Opções",
      icon: "las la-ellipsis-v",
      visible: () => false
    }
  ];
  primary: string = "idFeedbackQuestion";
  isValid: boolean = false;
  isLoading: boolean = false;


  async created(){
    const request = new GetFeedbackQuestionGroupDtosQuery();
    request.init(this.$route.query);
    request.idFeedback = this.feedback.idFeedback
    request.includes = new GetFeedbackQuestionGroupDtosIncludeOptions();
    request.orderBy = GetFeedbackQuestionGroupsDtosOrderOptions.OrderId
    request.take = 20;
    await this.feedbackQuestionGroupService
      .GetList(request)
      .then((result: ListResponse<FeedbackQuestionGroup>) =>
         this.groups =(result.data)
      )
      .catch((error: any) => console.log(error))
      .finally(() => (this.isLoading = false));
    
    const typeRequest = new GetFeedbackQuestionTypesDtosQuery();
    typeRequest.init(this.$route.query);
    typeRequest.idLanguage=1;

    await this.feedbackQuestionTypeService
      .GetList(typeRequest)
      .then((result: FeedbackQuestionGroup[]) =>
         this.questionTypes =(result)
      )
      .catch((error: any) => console.log(error))
      .finally(() => (this.isLoading = false));

    this.columns[2].arg.items = this.questionTypes;
    this.columns[2].arg.value =this.questionTypes[0];

    this.columns[3].arg.items = this.groups;
    this.columns[3].arg.value =this.groups[0];
  }
}
